const en = {
  global: {
    my_resume: 'My CV',
    resume: 'CV',
    ok: 'OK',
    or: 'or',
    and: 'and',
    step: 'Step',
    yes: 'Yes',
    no: 'No',
    employment: 'Employment',
    from: 'From',
    to: 'To',
    start: 'Start',
    end: 'End',
    new: 'New',
    more_info: 'More info',
    trade: 'Trade',
    experience: 'Experience',
    place: 'Place',
    suggested: 'Suggested',
    titles: {
      all_done: 'Done',
      fill_out_form: 'Fill out the form',
      sent: 'Sent',
      added: 'Added',
      saved: 'Saved',
      welcome: 'Your registration was successful! Welcome to Koderia',
    },
    actions: {
      create_resume: 'Create',
      save: 'Save',
      recommend: 'Recommend',
      share: 'Share',
      upload_file: 'UPLOAD FILE',
      send: 'Send',
      continue: 'Continue',
      back: 'Back',
      select: 'Select',
      delete: 'Delete',
      delete_account: 'Delete account',
      add_post: 'Add a post',
      open: 'OPEN',
      upload_files: 'UPLOAD FILES',
      IMPORT: 'IMPORT',
      add_more: 'Add more',
      add: 'Add',
      add_another: 'Add another',
      copy: 'Copy',
      complete: 'Complete',
      resend: 'Resend',
      show_less: 'Show less',
      unlock: 'Unlock',
      change_image: 'Change image',
      change_logo: 'Change logo',
      publish: 'Publish',
      back_to_home_page: 'Back to the homepage',
      edit: 'Edit',
      download: 'Download',
      close: 'Close',
      register: 'Register',
      confirm: 'Confirm',
      more: 'More',
    },
    time: {
      monthly: 'Monthly | Monthly',
      annual: 'Annual',
      today: 'Today',
      hour: 'hr',
      year: 'Year',
      years: 'year | years | years',
      month: 'Month',
      months: 'month | months | months',
      several_weeks: 'in a few weeks',
      months_3: '3 months',
      months_6: '6 months',
      manday: 'man-day',
      now: 'Now',
      later: 'Later',
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
    },
    errors: {
      unknown: 'An error occurred. Please try again later.',
      already_exists: 'The e-mail address is already in use by another account.',
      auth_expired_action_code: 'The token has expired.',
      auth_invalid_action_code: 'Invalid token.',
      auth_user_disabled: 'The account has been disabled.',
      auth_user_not_found: 'Invalid credentials.',
      auth_weak_password: 'The password is not strong enough.',
      auth_email_already_in_use: 'The e-mail address is already in use by another account.',
      auth_invalid_email: 'Invalid e-mail.',
      auth_operation_not_allowed: 'The operation is not allowed.',
      auth_account_exists_with_different_credential: 'Account already exists with different credentials.',
      auth_invalid_credential: 'Invalid credentials.',
      auth_wrong_password: 'Incorrect password.',
      auth_invalid_phone_number: 'Invalid phone number.',
      auth_missing_phone_number: 'Missing phone number.',
      auth_cancelled_popup_request: 'The popup has been closed.',
      auth_popup_blocked: 'The popup has been blocked.',
      auth_popup_closed_by_user: 'The popup was closed before the operation was completed.',
      auth_user_token_expired: 'The token has expired.',
      auth_invalid_api_key: 'Invalid API key.',
      auth_network_request_failed: 'A network error has occurred. Please try again later.',
      auth_requires_recent_login: 'Recent login is required.',
      auth_too_many_requests: 'Too many requests in a short time.',
      auth_invalid_password: 'Incorrect password.',
      auth_email_already_exists: 'The e-mail address is already in use.',
      auth_phone_number_already_exists: 'The phone number already exists.',
      auth_insufficient_permission: 'You do not have sufficient permissions.',
      auth_internal: 'An error occurred. Please try again later.',
      permission_denied: 'You do not have sufficient permissions.',
      phone_codes_error: 'There was a problem loading the country phone codes. Please try again later.',
      unexpected_error: 'An unexpected error occurred. Please try again later.',
      error_404: 'There was a problem loading the data: "{name}". Please try again later.',
      job_application_unavailable: 'It is currently not possible to apply for this job.',
    },
    inputs: {
      examples: {
        name: 'John',
        email: 'john.dear@gmail.com',
        searchJob: 'Search for Frontend, Linux, SQL...',
      },
      firstname_surname: 'First Name and Last Name',
      email: 'E-mail',
      first_name: 'Name',
      last_name: 'Surname',
      password: 'Password',
      city: 'City',
      experiences: 'Experience',
      phone: 'Phone number',
      profession: 'Profession',
      technology: 'Technology',
      name: 'Name',
      company: 'Company',
      position: 'Position',
      title: 'Title',
      search_expertise: 'Search technology.',
    },
    form_rules: {
      length_6: '6 or more characters.',
      non_empty_field: 'Please fill in this field.',
      valid_email: 'Please enter a valid e-mail address.',
      phone_number: 'The phone number must be in the format +421 9XX XXX XXX',
      min_3: 'At least 3',
      not_valid_email: 'The e-mail must be a valid e-mail address.',
      password_length: 'The password must contain at least 6 characters.',
      min_1_technology: 'Please enter at least 1 technology.',
      event_image_required: 'Event image is required.',
      event_name_required: 'Event name is required.',
      event_name_min_3_characters: 'The event name must be at least 3 characters long.',
      event_datetime_manadatory: 'The event date and time are mandatory.',
      link_format: 'The link does not have the correct format (example: https://koderia.sk/podujatia).',
      event_reference_required: 'The event reference is required.',
      venue_required: 'The event venue is mandatory.',
      event_description_required: 'The event description is required.',
      organizer_logo_required: 'The organiser logo is required.',
      organizer_name_required: 'The organiser name is required.',
      organizer_website_required: 'The organiser\'s website is mandatory.',
      organizer_description_required: 'The description of the organiser is mandatory.',
      organizer_description_long: 'The organiser description is too long.',
      event_end_before_start: 'The end of the event must not be before its start.',
      required_field: 'Required field',
      first_name_filled: 'First name must be filled out.',
      last_name_filled: 'Last name must be filled out.',
      password_min_six_characters: 'Password must contain at least 6 characters.',
      accept_terms_conditions: 'You must accept the terms and conditions.',
      no_data: 'No data available',
    },
    form_errors: {
      check_entered_information: 'An error has occurred. Check the entered information.',
      upload_photo_max_size_5mb: 'Failed to upload photo, maximum size is 5 MB.',
      enter_name: 'Please enter your first name.',
      enter_last_name: 'Please enter your last name.',
      enter_email: 'Please enter your e-mail.',
      select_phone_code: 'Please select your country phone code.',
      enter_phone_number: 'Please enter your phone number.',
      valid_phone_number: 'Please enter a valid phone number.',
      forgot_profession: 'Did you forget to fill in your profession?',
      select_available_from_date: 'Please select an available from date.',
      no_data_available: 'No data available',
      select_utm_source: 'Please select how you find out about us.',
      select_non_it_registration_reason: 'Please select your reason for registering.',
    },
    deprecated: {
      agree_with_processing_personal_data_according_to_current_working: 'I agree with the processing of personal data according to the current wording.',
      privacy_policy_small: 'Privacy policy',
      confirm_that_koderia_contact_me_in_future: 'I confirm that Koderia may contact me in the future.',
    },
    expertiseTypes: {
      PROGRAMMING_LANGUAGE: 'Programming language',
      FRAMEWORK: 'Framework',
      DATABASE: 'Database',
      LIBRARY: 'Library',
      LIBRARY_OR_FRAMEWORK: 'Library / Framework',
      CLOUD: 'Cloud',
      TOOLS: 'Tools',
      PLATFORM_OR_TOOL: 'Platform / Tool',
      METHODOLOGY: 'Methodology',
      DEVOPS: 'Dev / Ops',
      OTHER: 'Other',
    },
    expertiseLevel: {
      '0-1': 'Less than 1 year',
      1: '1 year',
      2: '2 years',
      3: '3 years',
      4: '4 years',
      '5-10': '5 – 10 years',
      '10+': 'More than 10 years',
    },
    utm_source: {
      referral: 'Referral',
    },
    non_it_registration_reasons: {
      student: 'I\'m studying IT and in the future I hope to become an IT specialist.',
      no_contact: 'I\'m an IT person, but I don\'t want you to contact me with job offers.',
      try_tools: 'I just want to try Koderia tools (e.g., Salary calculator, My CV).',
    },
  },
  ad: {
    not_interested_in_any_position: 'Were you not interested in any position? Tell us what your ideal project looks like and we\'ll find it.',
    do_you_know_anyone_might_be_interested_in_this_position: 'Do you know anyone who might be interested in this position? Recommend him / her and get a commission.',
    every_day: 'every day',
    you_can_also_have_commission_from_this_position: 'You can also earn a commission from this position.',
    do_you_know_anyone_might_be_interested_in_position: 'Do you know anyone who might be interested in these positions? Recommend him / her and get a commission.',
  },
  auth: {
    titles: {
      create_account: 'Create an account',
      account: 'Account',
    },
    subTitles: {
      account_advantages: 'Enjoy all the benefits of Koderia account free of charge.',
      verification: 'Account verification needed',
    },
    actions: {
      sign_up_simple: 'Sign up',
      sign_in_simple: 'Sign in',
      sign_in: 'Sign in',
      sign_up: 'Sign up',
      logout: 'Log out',
      create_new_account: 'Create a new account',
      create_account: 'Create an account',
      forgot_password: 'Forgot password',
      sign_in_here: 'Sign in here',
      sign_up_here: 'Sign up',
      verify: 'Send verification',
    },
    descriptions: {
      check_email: 'Check your e-mail inbox, as well as the spam folder. If you are unable to log in, write to us at:',
      dont_have_account: 'Don\'t have an account yet?',
      email_associated_with_koderia: 'If the given e-mail address is associated with an account on Koderia, we\'ll send a link to reset the password.',
      check_confirmation_email: 'Please check your e-mail inbox. We\'ve sent you a confirmation e-mail.',
      check_welcome_email: 'Please check your e-mail inbox. We have sent you a welcome e-mail.',
      already_have_account: 'Already have an account?',
      advantage_1: 'Access to valuable Koderia services.',
      advantage_1_message: 'The popular services Adequate salary, Salary calculator and Koderia Extra all in one place.',
      advantage_2: 'Simple response to IT projects.',
      advantage_2_message: 'Thanks to the pre-filled in forms, you can respond to Koderia IT projects and services with just one click.',
      advantage_3: 'Personalised job offers',
      advantage_3_message: 'Job offers customised and sorted based on your specialisation',
      advantage_4: 'Transparent cooperation',
      advantage_4_message: 'An overview of your data and the services used, which you can return to or modify at any time.',
      verification_dialog_message: 'Please verify your e-mail address to access this section. We\'ve sent a verification link to your registered e-mail. Click the link in the e-mail to proceed. If you haven\'t received the e-mail, please check your spam folder or request a new verification e-mail.',
      non_it_description: 'If you select the option that you are not from the IT field, we will not contact you or offer you work on projects. However, if you decide to change your focus in the future, you can always edit it in your profile. If you just chose the wrong profession or you don\'t know how to classify yourself, please select the OTHER option.',
    },
    inputs: {
      remember_login: 'Remember login',
    },
  },
  cookie: {
    description: 'The Koderia.sk website uses cookies to provide services and traffic analysis. By continuing to browse, you agree to their use.',
    more_information: 'More information.',
    button: 'I understand and agree.',
  },
  navigation: {
    titles: {
      job_offer: 'Job Offers',
      legal_information: 'Legal information',
      social_network: 'Social networks',
      it_specialists: 'For IT specialists',
      companies: 'For companies',
      menu: 'Menu',
      next: 'Next',
    },
    home: 'Home',
    jobs: 'IT projects',
    companies: 'For companies',
    specialists: 'For IT specialists',
    carrier: 'Carrier',
    events: 'Events',
    blog: 'Blog',
    newsfeed: 'Newsfeed',
    dictionary: 'Dictionary',
    what_is_koderia: 'What is Koderia?',
    adequate_salary: 'Adequate salary',
    calculator: 'Salary Calculator',
    work_comparison: 'Work comparison',
    work_types_comparison: 'Comparison of work type',
    koderia_referral: 'Koderia Referral',
    koderia_extra: 'Koderia Extra',
    privacy_policy: 'Privacy Policy',
    resume: 'CV',
    create_resume: 'Create CV',
    terms_conditions: 'Terms and Conditions',
    koderia_dictionary: 'Koderia Dictionary',
    about_us: 'About Us',
    contact_us: 'Contact',
    policy: 'Policy',
    settings: 'Settings',
    create_new_koderia_biography: 'Create a new Koderia CV',
    company_services: 'Services',
    company_cases: 'Case studies',
  },
  homepage: {
    home: 'Homepage',
    subtitles: {
      blogs: 'Latest blogs',
      career_it: 'Career for IT specialists',
      company_solutions: 'IT solutions <br /> for companies',
      cv_feature: 'Modern and Clear CVs.<br />For Everyone in IT.<br />Free of Charge.',
      adequate_salary_feature: 'Adequate Salary',
      salary_calculator_feature: 'Salary Calculator',
      they_said: 'They said about us',
      our_projects: 'Our projects',
      companies_trust: 'Trust from leading companies',
      open_projects: 'Open IT Projects',
      features: 'Created for you. Free of charge.',
    },
    descriptions: {
      career_it: 'If you\'re seeking genuine growth in your IT career, you\'re in the right place. Our platform offers opportunities that may exceed your expectations. Try something new and discover all that you can achieve.',
      company_solutions: 'Are you looking for IT specialists for your project or a customised solution?',
      cv_feature: 'Create a responsive CV in just a few minutes,<br /> which you can edit, share, or print at anytime.',
      adequate_salary_feature: 'How are the skills and experience you\'ve<br /> gained so far valued?',
      salary_calculator_feature: 'Are you working under a permanent<br /> employment contract? Find out how much<br /> you would earn as a freelancer or through<br /> a limited liability company.',
    },
    actions: {
      show_all: 'Show All',
      show_projects: 'Show IT projects',
      more_info: 'More info',
    },
  },
  project: {
    title: 'Is your colleague, friend, or acquaintance planning to change jobs?',
    subtitles: {
      referral: 'Is your colleague, friend, or acquaintance planning to change jobs?',
      extra: 'Was no position of interest to you?',
    },
    descriptions: {
      referral: 'Recommend him to one of our projects and if come to a successful agreement, you\'ll earn a commission every day.',
      extra: 'Fill out a short form and we will search for a <br class="tw-hidden md:tw-block" /> project for you according to your selected requirements.',
    },
    actions: {
      learn_more: 'Learn more',
      reset_filters: 'Reset filters',
    },
    detail: {
      status: {
        not_available: 'This project is already taken or is out of date.',
        new: 'New',
        remote: 'Remote',
        already_responded: 'You have already responded to this offer.',
      },
      subtitles: {
        position: 'Position description',
        hr_need_info: 'Need more info?',
        interest_contacts: 'Contact information and CV',
        good_news: 'Good news',
        interest_upload_resume: 'Upload CV now?',
      },
      descriptions: {
        useful_for_you: 'According to the info in your profile and CV, this job could be suitable for you. Don\'t miss the opportunity to work on what you want.',
        create_resume: 'Create a Koderia CV and find out how your experience matches the requirements for this job offer.',
        team_contacts_you: 'Over the next few days, a member of our team will contact you and agree with you on the next steps.',
        modern_resume: 'A modern and clear CV for <br class="md:tw-hidden" /> everyone in IT.',
        hr_contact_directly: 'Contact our recruiters directly. They\'ll be happy to tell you more.',
        interest_team_contacts_you: 'Thank you for your interest. We will contact you soon.',
        interest_recommended_upload: 'We recommend uploading now, as we will need it.',
      },
      actions: {
        respond_to_offer: 'Apply for job',
        all_jobs: 'All jobs',
      },
      salary: 'Salary',
      location: 'Location',
      views: 'view | views | views',
      candidates: 'candidate | candidates | candidates',
      requirements: 'Requirements',
      employer_benefits: 'Employer benefits',
      project_duration: 'Project duration',
      duration_extension: 'with the possibility of extension',
      start_date: 'Start date',
      type: 'Type',
      tpp: 'TPP',
      contract: 'Contract',
      agreement: 'Agreement',
      project_language: 'Language on the project',
      similar_job: 'Similar Jobs',
      free: 'Free',
      salary_per_contract: 'Salary per contract',
      salary_per_tpp: 'Salary per TPP',
      top_offer: 'Top offer',
      email_reaction_to: 'Reaction to',
      email_body: 'Please, don\'t forget to attach a CV.',
    },
  },
  event: {
    title: 'Upcoming events',
    subtitles: {
      online: 'Online',
      slovakia_czech: 'Slovakia and the Czech Republic',
      event_info: 'Event info',
      organizer: 'Organiser',
    },
    descriptions: {
      upload_cover_image: 'Upload a cover image',
      basic_information: 'Basic information about the event, such as the name, place, description and time of the event.',
      organizer_information: 'Brief information about the event organiser.',
      no_scheduled_events: 'No events are currently scheduled.',
    },
    detail: {
      action: 'Add to calendar',
    },
    inputs: {
      event_link: 'Link to event',
      list: 'Description',
      ticket_purchase_link_optional: 'Ticket Purchase Link (Optional)',
      webpage: 'Webpage',
      description_of_organizer: 'Description of the organiser',
      date_and_time: 'Date and Time',
    },
    cover_image: 'Cover image',
    date_and_time: 'Date and Time',
    online_event: 'Online event',
    organize_question: 'Are you organising an event?',
  },
  blog: {
    title: 'Koderia Blog',
    subtitles: {
      more_articles: 'Additional articles',
    },
    description: 'We write about topics that resonate with the IT world.',
    actions: {
      read: 'Read',
      more_articles: 'Additional articles',
    },
    detail: {
      subtitle: 'You might be interested',
    },
  },
  newsfeed: {
    title: 'Newsfeed',
    action: 'Additional articles',
  },
  questionaire: {
    title: 'Adequate salary',
    subtitles: {
      experience: 'How are the experiences you\'ve had thus far appreciated <br class="tw-hidden lg:tw-block" />?',
      paid_jobs: 'Adequately paid jobs',
      evaluate_resume: 'Evaluate your CV',
      choose_method: 'Choose an evaluation method',
      about_you: 'Information about you',
      master_technologies: 'Technologies you have mastered',
      total_experience: 'Total years of experience',
      master_experience: 'Number of years of experience in',
      leadership_experience: 'Have you ever been a Team Leader or Scrum Master?',
      domain_experience: 'Do you have experience with a specific domain?',
      domain_experience_examples: '(e.g. Banking, Medicine, Telecommunications,…)',
      software_architect_experience: 'Have you worked as a software architect?',
      type_of_tester: 'What type of tester are you?',
      ci_experience: 'Do you have experience with CI technologies Docker, Jenkins, GIT, ...?',
      performance_experience: 'Do you have experience with performance test programming?',
      job_listing_title: 'Job list',
    },
    descriptions: {
      salary_evaluate: 'We evaluate your salary based on the experience you have gained in your career. The evaluation is done by uploading your CV or filling out the form. Both options are highly accurate.',
      experience_evaluate_by_team: 'A member of the Koderia team will evaluate your experience.',
      experience_evaluate_by_system: 'Your experience will be evaluated by our sophisticated system.',
      experience_evaluate_by_pro_team: 'A member of the Koderia PRO team will evaluate your experience.',
      first_step: 'In the first step, it is important to find out which technologies you have mastered and the number of years of experience you have.',
      second_step: 'In the second step, provide additional information about your career so far.',
      third_step: 'Finally, leave us your name and e-mail, where we will send the result of the form.',
      answer_questions: 'Answer the following questions.',
      thank_you: 'Thank you for your interest, we will contact you soon.',
    },
    actions: {
      all_jobs: 'All jobs',
      upload_resume: 'Upload CV',
    },
    inputs: {
      choose_position: 'Select a position',
    },
    programmer: 'Programmer',
    tester: 'Tester',
    it_specialist: 'IT specialist',
    project_manager: 'Project manager',
    analyst: 'Analyst',
    automated_tester: 'Automated tester',
    manual_tester: 'Manual tester',
  },
  calculator: {
    title: 'Salary calculator',
    subtitles: {
      only_for_slovak: 'Only applicable in the Slovak Republic',
      possible_earnings: 'Do you work a full-time job?<br class="tw-hidden lg:tw-block" />Find out how much you would earn on a <b>trade licence</b> or as an <b>LLC</b>.',
      find_out_more: 'Find out more, <span class="tw-text-green">for free</span>.',
      billing_options: 'Invoicing options',
      price_md: 'Price per man-day',
      price_md_sup: '(Man-day Rate)',
      recommended_job_offers: 'Job offers for you',
    },
    actions: {
      calculate: 'Calculate',
      find_job: 'Find a job',
      get_hired: 'Get hired',
    },
    descriptions: {
      main: 'The Salary Calculator tool calculates the amount you should invoice if you work for on a trade licence or as an LLC from the TPP so that <b>the employer\'s costs do not increase.</b>',
      current_income: 'Your current income and contributions on a full-time job.',
      more_after_login: 'We will be happy to show you more for free after you log on.',
      more_after_verify: 'We will be happy to show you more for free after we verify your e-mail.',
      your_md_rate: 'What is your Man-day rate',
      earn_for_trade: 'How much you will earn as a trade-licence holder.',
      earn_on_sro: 'How much you will earn if you have your own company (LLC).',
      fees_and_taxes: 'What contributions and taxes you will pay.',
      option_for_you: 'Which option is more worthwhile for you.',
      net_monthly_income: 'This is the amount you should receive when you switch to an invoice.',
    },
    inputs: {
      gross_monthly_income: 'Enter your gross monthly income (min. 700 €)',
    },
    taxes: 'taxes',
    net_monthly_income: 'Net monthly income',
    months_worked_in_year: 'Months worked in the year',
    super_gross_annual_salary: 'Super-gross annual salary',
    employer_levies: 'Employer contributions',
    employee_contributions: 'Employee contributions',
    invoice_for_year: 'Invoiced per year',
    deductions_together: 'Contributions together',
    income_tax: 'Income tax',
    price_md: 'Price per man-day',
    invoice_md: 'The amount you should invoice per working day.',
    trade_first_year: 'Trade-license in the first year',
    trade_2nd_and_next_year: 'Trade-licence in the 2nd and following year',
    average_net_monthly_income: 'Average net monthly income',
    taxes_and_levies: 'Taxes and contributions',
    health_insurance_contributions: 'Contributions to the health insurance company',
    social_insurance_contributions: 'Payments to the social insurance system',
    together: 'Total',
    billing_options_learn_more: 'Learn more about invoicing options in',
    billing_options_learn_more_link: 'this article.',
    company_sro: 'Company (LLC)',
    company_tax: 'Company tax',
    dividend_tax: 'Dividend tax',
    total_taxes: 'Total taxes',
    overview: 'Overview',
    price_of_labor: 'Price of work',
    super_gross_salary: 'Super-gross salary',
    gross_salary: 'Gross salary',
    gross_salary_after_tax: 'Gross salary after tax',
    net_income: 'Net income',
    average_invoice: 'Average invoice',
    company_profit: 'Company profit',
    gross_tax_base: 'Gross tax base',
    flat_cost: 'Flat costs',
    health_insurance: 'Health insurance',
    social_insurance: 'Social insurance',
    view_detailed_taxes_and_levies: 'Show detailed taxes and contributions',
  },
  work_comparison: {
    title: 'Comparison of forms of work',
    subtitle: 'Find out which form <br class="tw-hidden lg:tw-block" />of work is best for you.',
    subheadings: {
      accounting: 'Accounting',
      establishment: 'Establishment',
      taxes: 'Taxes',
      non_taxable_part: 'Non-taxable part',
      levies: 'Contributions',
    },
    descriptions: {
      main: 'Detailed comparison of full-time employment, <br class="tw-hidden lg:tw-block" />contracts and limited liability companies (LLCs).',
      taxes_follows_law: 'It follows from the wording of the law that the {percentage}% tax rate will be applicable to taxpayers with a turnover of up to {grossTax} € from {year}.',
      annual_amount_non_taxable_part: 'The annual amount of the non-taxable part of the taxpayer\'s tax base in {year} is {untaxablePartOfTaxBase} €, if the tax base is less than or equal to {minimumTaxBase} €. From this amount until the tax base is higher than the amount of {milionaireTaxBase} €, the non-taxable part decreases to zero.',
      social_insurance_not_paid: 'Social insurance is not paid. The minimum health insurance is paid. In the following years, social security contributions apply if in the previous year it exceeded the income limit of {minimumYearWage} € (for {year}); the contributions increase together with income; payments are made to the health insurance company even if nothing is earned (the minimum amount of contributions is {minimumMedicalTax} € per month).',
      manager_one_person: 'If the manager is one person and does not pay his own salary, he does not have to pay social security contributions and pays health insurance as a self-paying person; however, if the manager is also an employee, he must pay contributions to both the health and social insurance company.',
    },
    permanent_employment: 'Full-time employment',
    self_employed_person: 'Self-employed person',
    limited_liability_company: 'Limited Liability Company',
    simple: 'simple',
    double: 'double-entry',
    income_tax: 'income tax',
    dividend_tax: 'dividend tax',
    other: 'Other',
    holiday: 'holiday',
    sick_leave: 'sick leave',
    retirement_savings: 'retirement savings',
    low_contributions_low_pension: 'low contributions = low pension',
    benefits: 'Benefits',
    disadvantages: 'Disadvantages',
    regular_income: 'regular income',
    financial_benefits: 'financial and non-financial benefits',
    get_loan: 'easier to get a loan',
    lower_salary: 'lower salary',
    working_hours: 'precisely set working hours',
    notice_period: 'notice period',
    fast_establishment_process: 'fast and cheap process of establishment',
    possible_flat_rate_expenses: 'possibility of using flat-rate expenses',
    social_contributions_exemption: 'exemption from social security contributions during the first year',
    unlimited_liability: 'unlimited liability',
    health_social_contributions_amount: 'health and social security contributions depend on the amount of income',
    less_credible_image: 'less credible image (for business partners it may give the impression of a small entrepreneur)',
    limited_liability: 'limited liability',
    credible_image: 'better and more credible image (gives the impression of a bigger and more serious entrepreneur for business partners and potential employees)',
    equal_income_tax: 'flat income tax regardless of the income earned',
    expensive_founding_process: 'a longer and more expensive founding process, including the need to develop founding documents',
    demanding_administration: 'more demanding and expensive administration (mandatory double-entry bookkeeping), 50 - 70 euros/month',
    termination_process: 'more complicated termination process',
    graph_net_income: 'Graph comparison of net income',
    company: 'Company',
    trade_after_first_year: 'Trade-licece after the first year',
    temporary_incapacity_for_work: 'Temporary incapacity for work',
    gross_salary: 'Gross salary (Invoiced amount)',
    chart_popup_more_info: 'For more accurate data, visit the salary calculator',
  },
  extra: {
    title: 'Extra',
    subtitles: {
      your_idea: 'Tell us what your <br class="tw-hidden lg:tw-block" />work should look like.',
      project_information: 'Information about the project',
      information_about_you: 'Information about you',
      preferred_technologies: 'Preferred technologies',
    },
    descriptions: {
      no_interested_position: 'Were you not interested in any position? Fill out a short form and we\'ll search for a project for you based on the selected requirements.',
      will_be_in_touch: 'Thank you. We will be in touch soon. In the meantime, you can see what\'s new on the homepage.',
    },
    inputs: {
      date_of_start: 'Start date',
      phone_number_optional: 'Phone number (Optional)',
      question_or_additional_info: 'Questions or additional info (Optional)',
    },
    junior_less_than_2_years: 'Junior (less than 2 years)',
    medior_2_4_years: 'Medior (2 - 4 years)',
    senior_5_and_more: 'Senior (5 and more)',
  },
  referral: {
    title: 'Koderia Referral',
    subtitles: {
      colleague_planning: 'Do you have a colleague, friend <br class="tw-hidden lg:tw-block" />or acquaintance who is planning to change jobs?',
      how_it_works: 'How does it work?',
      forms_of_payment: 'Forms of payment',
      one_time_commission: 'one-time commission',
      worked_day: 'for every day worked',
      ready_to_collaborate: 'Ready to collaborate?',
      candidate_information: 'Candidate information',
      information_about_you: 'Information about you',
      you_should_know: 'You should know',
    },
    descriptions: {
      recommend_projects: 'Recommend him or her for one of our projects and if a mutual agreement is reached, you\'ll earn a commission every day.',
      friend_looking: 'It\'s simple. You let us know about your friend or colleague who you know is looking for a job in IT. We will place him or her on one of our projects, and the commission is yours.',
      fill_short_form: 'Fill out a short form, on whose basis we will contact your friend.',
      interview_with_you: 'We will arrange an interview either with use or the client, where we figure out if the expectations are mutual.',
      concluding_contract: 'Signing a contract with a successful candidate and payment of the commission.',
      one_time_commission: 'We pay a one-time commission after the first three months worked. We pay € 5 for each day worked monthly, from the beginning to the end of the project. For projects shorter than 6 months, we pay € 500 or € 5 for each day worked. We also pay a commission if we agree with the candidate on another position.',
      recommendation_touch_soon: 'Thank you for your recommendation. We will be in touch soon. In the meantime, you can see what\'s new on the homepage.',
      recommend_to_position: 'Are you recommending a friend for a specific position?',
      preferred_type_of_provision: 'What type of commission do you prefer? (Optional)',
      change_provision_type: 'You can change the selected type of commission at any time.',
      forms_of_reward: 'The forms of remuneration are: a one-time commission in the amount of <b>€1000</b>, which we pay after the first three months of work or <b>€5&nbsp; for each day of work</b>, from the beginning to the end of the project (paid monthly).',
      shorter_projects: 'For projects shorter than 6 months, we pay € 500 or € 5 for each day worked.',
      receive_commission: 'You will also receive a commission if we agree with the candidate on another position.',
      data_deleted_from_db: 'Your data will be deleted from our database.',
      recommended_you: 'You have been recommended you for one of our vacancies. If you do not know the person who sent us your information, click on the button below and delete your data.',
    },
    inputs: {
      current_position: 'Current position',
    },
    one_time_1000: '€ 1,000 one time',
    per_day_worked_5: '€ 5 per day worked',
    record_not_found: 'Record not found.',
  },
  koderia_about: {
    title: 'What is Koderia?',
    descriptions: {
      unique_project: 'Koderia is a unique project where all programmers, IT enthusiasts, students of technical subjects, as well as people who are close to the world of IT will find something to their liking. Find out everything Koderia has to offer below.',
      homepage: 'The Koderia homepage is a stepping stone to all the features and options we offer. You will find the latest job offers, contributions from global portals, IT events in Slovakia as well as online from around the world, and much more.',
      job_section: 'In the job section you\'ll find the latest job offers. We mediate work in companies that are leaders in their field in Slovakia, the Czech Republic, and Austria. We already have dozens of coders under our wings and support.',
      looking_for_colleague: 'Do you have a colleague, friend, or acquaintance looking to work in IT? Let us know about it. If we come to an agreement and start to cooperate, we\'ll share a commission with you. You can earn € 5 a day or a flat rate of € 1,000.',
      interested_offer: 'Were you not interested in any job offer? By filling out a short form on our website, you can let us know what kinds of jobs you are interested in, and we will contact you if we find such an offer.',
      modern_resume: 'A modern and clear CV that you can share or print with one click should be a given for everyone these days, mainly in the IT sector.',
      salary_tool: 'A simple tool that determines your salary based on your experience.',
      trade_to_sro: 'Calculation of the invoiced amount upon the transition from full-time employment to a trade-licence or an LLC.',
      blog: 'The blog has its own page. In it, we write about topics that resonate in the IT world and ideas that we identify with.',
    },
  },
  profile: {
    title: 'Koderia account',
    subtitles: {
      email_settings: 'E-mail settings',
      invalid_link: 'Invalid link',
      thank_you: 'Thank you',
      linkedin_import_data: 'Import data from LinkedIn',
      account_settings: 'Account settings',
      newsletter: 'Newsletter',
      basic_settings: 'Basic settings',
      delete_account: 'Are you sure you want to cancel your account?',
      confirm_email_address: 'Confirm e-mail address',
      finish_signup: 'Before you begin, <br class="tw-hidden lg:tw-block" />tell us <br class="tw-hidden lg:tw-block" />something about yourself.',
    },
    descriptions: {
      invalid_link: 'The link is not valid or it has expired.',
      recommended_salary: 'Your salary should not be less than',
      find_out_recommended_salary: '<span>Fill out the <a href="#" @click.prevent="$emit(\'go-to-experience\')" class="tw-text-black">experience</a> section</span><br /><span>and find out how much you should be earning.</span>',
      approval_of_contribution: 'We will inform you about the approval of the contribution. You can then find your added posts in the menu, in the "Added" section.',
      share_original_posts: 'Share with us the original posts on the Internet that interested you.',
      no_posts: 'You have not yet added any posts.',
      linkedin_open_personal_data: 'Open a subpage about your personal data.',
      linkedin_use_your_data: 'How LinkedIn uses your data.',
      linkedin_download_large_data: '<p class="step-info">Choose the option <strong>Download larger data archive…</strong></p>',
      linkedin_request_archive: '<p class="step-info">Then click on <strong>Request archive</strong></p>',
      linkedin_unzip_file: 'Unzip the file you downloaded and upload the files to us.',
      linkedin_provide_file: 'Please note that LinkedIn may not provide you with the file immediately.',
      import_click: 'Then click on <strong>Import</strong>.',
      private_resume: 'The CV is set as private. You can change it in',
      token_resume_no_password: 'The CV password is not set. You can set it in',
      private_resume_change: 'settings, Privacy section',
      what_is_experience_chart: 'What does this chart represent and how does it work?',
      fill_in_experience_chart: 'For the correct display of the chart, fill in your experience.',
      resume_link: 'At this link you and the people you share it with will find your CV.',
      resume_language: 'The language in which the CV is displayed.',
      resume_social_contact: 'Showing the e-mail address, phone number and website or social network in the CV.',
      resume_availability: 'Choose who you want to make your CV available to.',
      account_password_not_allowed: 'Do not enter the password from your account!',
      resume_password_viewing_only: 'This password is only for viewing your CV and will only be available to people you choose to give it to.',
      digital_experience_graph: 'Showing the experience chart in the digital version of the CV.',
      positions_based_on_technologies: 'New positions according to the technologies you specified in your account settings.',
      sending_news: 'Everything that is new on our portal. We send continuously, at most 1x per month.',
      new_blog_articles: 'New articles from our blog - a maximum of 1x per week.',
      account_cancellation_undone: 'The account cancellation cannot be undone. Are you sure you want to cancel your account?',
      no_posts_saved: 'You have not yet saved any posts.',
      no_events_saved: 'You have not yet saved any events.',
      no_job_offer_saved: 'You have not yet saved any job offers.',
      confirm_email_address: 'We have sent you a link to confirm your e-mail to the e-mail address <span class="tw-font-bold">{email}</span>. Check your e-mail inbox, and just to be sure, check your spam folder.',
      basic_information: 'Essential information that every CV must have.',
      about_me_input: '2-3 short sentences about who you are and what you specialise in.',
      employment: 'Provide information about your employment history. Start from the latest or current.',
      stack: 'Pick up to 9 items from stack that are most valuable for you and that you have the most experience in.',
      stack_notify: 'We have already picked some technologies for you from the previous section 😎',
      education: 'Provide information about your secondary school, college or university. Start from the latest.',
      education_diploma_placeholder: 'Master of engineering or something, I don\'t know; I didn\'t study...',
      references: 'Add information about projects you have worked on and which are already online.',
      references_description_input: 'Write a short description of the project, or leave it blank.',
      certificates: 'If you have any certificates that you want to show, this is the place to do it.',
      certificates_description_input: 'Write a short description, if necessary',
      languages: 'Let your future employer know what languages you speak.',
      technology_input: 'Choose the technologies that you used when employed.',
      employment_description_input: 'Write about 3-7 sentences about your job and what were you responsible for.',
      education_description_input: 'Write about 3-6 sentences about your studies.',
      cv_generation_in_progress: 'Your CV is being generated. Once it is finished, you\'ll receive the CV in your e-mail inbox: <b>{e-mail}</b>',
    },
    actions: {
      fill_position: 'Fill in your position',
      respond_to_offer: 'Respond to offer',
      move_down: 'Move down',
      move_up: 'Move up',
      delete_photo: 'Delete photo',
      change_photo: 'Change photo',
      upload_photo: 'Upload photo',
      delete_custom_cv: 'Delete CV',
      change_custom_cv: 'Change CV',
      upload_custom_cv: 'Upload CV',
      go_to_events: 'Go to events',
      show_posts: 'Show posts',
      find_job: 'Find a job',
      send_cv_by_email: 'Send by e-mail',
      show_resume: 'Show CV',
      create_koderia_cv: 'Create a new Koderia CV',
      pick_previous_tech: 'Select technologies from previous job',
    },
    inputs: {
      dominated_technologies: 'Technologies mastered',
      bio: 'Bio',
      current_email: 'Current e-mail',
      new_email: 'New e-mail',
      new_password: 'New password',
      url_link: 'URL link',
      description: 'Description',
      country: 'Country',
      education_diploma: 'Achieved education / Diploma',
      school_university: 'School / University',
      faculty: 'Faculty',
      technology_software_activity: 'Technology, software, activities…',
      numbers_of_years_of_experience: 'Number of years of experience',
      language: 'Language',
      level: 'Level',
      link: 'URL',
      web_social_network: 'Web / Social Network',
      about_me: 'Short info about you',
      new_jobs: 'New jobs',
      koderia_news: 'Koderia news',
      profession_finish_up: 'What best describes your profession?',
      country_finish_up: 'Where are you from?',
      technologies_finish_up: 'Which technologies are you using?',
      technologies: 'Technologies',
      non_it: 'I am not an IT person.',
      source_about_us: 'How did you find out about us?',
      non_it_registration_reason: 'Why did you decide to register?',
    },
    posts: 'Posts',
    data_in_cv: 'Data',
    basic_information: 'Basic information',
    education: 'Education',
    school: 'School',
    references: 'References',
    reference: 'Reference',
    technologies: 'Technologies',
    years_of_experience: 'Years of experience',
    certificates: 'Certificates',
    certificate: 'Certificate',
    languages: 'Languages',
    experience_chart: 'Experience chart',
    import_your_data_from: 'Import your data from',
    linkedin: 'LinkedIn',
    link: 'Link',
    language: 'Language',
    app_language: 'Application language',
    contact_information: 'Contact information',
    privacy: 'Privacy',
    graph: 'Chart',
    public: 'Public',
    registered_users: 'Registered users',
    private: 'Private',
    accessible_with_password: 'Accessible with a password',
    job_looking_finish_up: 'Are you currently looking for a job?',
    job_timeframe_finish_up: 'In what time horizon do you plan to look for a job?',
    job_listing_title: 'Job list',
  },
  gdpr: {
    title: 'Privacy Policy',
    default_agree: 'I agree with the processing of personal data according to the current',
    personal_data: 'personal data protection policy',
    descriptions: {
      privacy_policy_tooltip: 'By clicking the checkbox "I agree to the processing of personal data according to the current principles of personal data protection", you give the Operator consent to the processing of your personal data. The purpose of obtaining your personal data is to provide you, based on your request, with information about the adequate amount of salary for the specific chosen position. You give your consent to the processing of personal data for a period of 3 years, and you have the right to revoke it at any time at the e-mail address <u> kontakt@koderia.sk </u>. Withdrawal of consent does not affect the legality of the processing of personal data based on consent before its withdrawal.',
      receive_job_offers: 'I do not agree to the occasional sending of customised job offers',
      contact_tooltip: 'By clicking the check box "I agree to the processing of personal data according to the current principles of personal data protection", you give the Operator consent to the processing of your personal data and to their storage in the internal database. The purpose of processing your personal data is to find a suitable job. You give your consent to the processing of personal data for 5 years, and you have the right to revoke it at any time at our e-mail address <u> kontakt@koderia.sk </u>. Withdrawal of consent does not affect the lawfulness of the processing of personal data based on consent prior to its withdrawal.',
      register_account_tooltip: 'As part of the registration, by clicking the checkbox "I agree to the processing of personal data according to the current privacy policy", you give your consent to the processing of personal data and to their storage for the duration of the account\'s existence. You can request the cancellation of the account at any time and withdraw your consent to the processing of personal data at our e-mail address <u> kontakt@koderia.sk </u>. Withdrawal of consent does not affect the legality of the processing of personal data based on consent before its withdrawal. Based on the legal basis of legal basis of legitimate interest, in connection with the creation of an account, we will send you our newsletter with job vacancies and other information that may be of interest to you. If you do not wish to receive the newsletter, you can unsubscribe at any time in the account settings, e-mail settings section.',
      newsletter_personalized_offers: 'I agree to receive personalised job offers and news.',
      newsletter_contact_me_tooltip: 'By clicking the check box "I agree that Kodeira will contact me in the future and send me interesting news", you give the Operator your consent to the storage of personal data in the internal database for the purpose of sending marketing offers. The purpose of processing and storing your personal data is to send you marketing offers that could be of interest to you. You give your consent to the processing of personal data concerning the receiving of the newsletter for a period of 5 years, and you have the right to revoke it at any time on our Website via the e-mail address <u> kontakt@koderia.sk </u>. Withdrawal of consent does not affect the lawfulness of the processing of personal data based on consent prior to its withdrawal. Your CV will be deleted after the expiration of the consent period or after the withdrawal of the consent to the processing of personal data.',
      project_interest_agree_to_contact: 'I agree that Koderia will contact me in the future and send me interesting news.',
    },
  },
  404: {
    title: 'Page not Found',
    subtitle: 'Are you looking for a new job?',
    action: 'All jobs',
  },
  about: {
    title: 'Team of professionals',
    subtitles: {
      way_to_success: 'Our path to success',
      outsourcing_pros: 'Benefits of outsourcing with Koderia',
      contractors_db: '12+ thousand contractors in our internal database',
      personal_approach: 'Personal approach',
      selection_process: 'Quality selection process',
      contact_us: 'Contact us',
      koderia_team: 'Koderia team',
    },
    descriptions: {
      objectify: 'Koderia combines the outsourcing of IT specialists with comprehensive services at different levels of responsibility – from deployment of an experienced team that will deftly engage with your project to supplying turnkey software, where we take on the whole development, from assignment to deployment, from start to finish. We have cooperated long term with leading companies in Slovakia, the Czech Republic, Austria and the USA.',
      years_of_experience: 'Years of experience on the market',
      revenue: 'Revenue last year',
      candidates_count: 'developers',
      enterprise_clients_count: 'business clients',
      satisfied_it: 'satisfied IT specialists',
      monthly_developers_growth: 'monthly increase of candidates in the database',
      satisfied_clients: 'satisfied clients',
      delivered_candidates: 'successfully delivered man-hours',
      rocket: {
        '2025': 'Merger of the <span class="tw-text-koderia-alt tw-font-bold">Objectify and Koderia</span> brands',
        '2023_1': 'Salary calculator',
        '2023_2': 'with more than 500 thousands uses',
        '2022': 'Surpassing turnover of 2 million',
        '2021_1': 'Establishment of a',
        '2021_2': 'Koderia CV',
        '2021_3': 'and the possibility of logging into the portal',
        '2020_1': 'Launch of the unrivalled',
        '2020_2': 'Salary calculator',
        '2019': 'Brand creation',
        '2018_1': 'Launch of the Coders by Coders portal / Launch of the service',
        '2018_2': 'Adequate salary',
        '2014': 'Establishment of the Software House <span class="tw-text-koderia-alt tw-font-bold">Objectify, s.r.o.</span>',
      },
      contractors_db: 'And for each programmer, we have skills divided into competence centres, where we can precisely target job offers. Our specialists have a wide range of professional skills, including software development, data security, cloud technologies and many other IT areas.',
      personal_approach: 'We approach every contractor/programmer as if they were working at our company. We believe that our team of professional IT specialists can provide you with not only high-quality IT services, but also the feeling of working with an exceptional team that is fully committed to the success of your projects.',
      selection_process: 'Each team member has gone through a thorough selection process and has experience working on various projects in various industries. We provide professional IT specialists with rich experience and expertise for our clients\' projects.',
      feedback: 'Your feedback is very important to us, because it allows us to improve our services and contribute to creating a better community for programmers.',
      count_with_us: 'We are here to help you with information and find solutions that meet your needs.',
      form_sent_thank_you: 'Thank you for your message!',
    },
    inputs: {
      name: 'First and last name *',
      phone: 'Phone number *',
      url: 'Company or LinkedIn profile',
      message: 'Message *',
      gdpr: 'I agree to the processing of personal data',
    },
  },
  resume: {
    title: 'CV',
    subtitles: {
      modern_clear_cv: 'A modern and clear CV<br class="tw-hidden lg:tw-block" /> for everyone in the IT industry.',
      modern_clear_cv_free: 'free of charge.',
      tailored_cv: 'A CV tailored<br/> to your needs',
      unique_graph: 'Experience displayed in a clear chart',
      ready_to_print: 'CV ready for printing and secure sharing',
      experience_salary: 'The amount you should earn based on your experience.',
      reviews: 'Reviews',
      start_new_cv: 'Start writing your new CV',
      cv_is_secure: 'The CV is secured',
    },
    subheadings: {
      experience_chart: 'Experience chart',
      print_share: 'Sharing and printing',
      adequate_salary: 'Adequate salary',
      responsive_design: 'Responsive design',
      english_language: 'English language',
      password_protected: 'Password protected',
      it_sector_oriented: 'Oriented to the IT sector',
      linkedin: 'LinkedIn Import',
      easy_edit: 'Easy to edit',
      faq_1: 'Is creating a CV really free?',
      faq_2: 'How can I share my CV?',
      faq_3: 'Is the CV available in other languages?',
      faq_4: 'How do I import data from LinkedIn into my CV?',
    },
    descriptions: {
      create_responsive_resume: 'Create a responsive CV in a few minutes, which you can <b>edit</b>,<br class="tw-hidden lg:tw-block" /> <b>share</b>, or <b>print</b> any time.',
      tailored_cv: 'A Koderia CV is suitable for all people working in the IT industry, including frontend, backend, and full-stack developers, testers, IT specialists, administrators, or database specialists.',
      understand_experiences: 'What would it be like to see your experiences and understand them in seconds? A chart that visualises your achieved experience makes this possible.',
      share_and_print: 'Share your CV with everyone or just the people it\'s intended for. If necessary, print it as perfectly as on the screen.',
      experience_salary: 'The CV will show you the amount you should be earning based on the experience you have listed on your CV.',
      displayed_on_device: 'The CV will be displayed without problems on any device.',
      english_switch: 'You can switch your CV to English with one click.',
      intended_share: 'Show your CV to everyone or only to the people it\'s intended for.',
      unique_design: 'Unique CV design for people looking for jobs in the IT industry.',
      linkedin_import: 'You can easily transfer data to your CV from your LinkedIn account',
      edit_freely: 'Edit your CV whenever need and from any device.',
      faq: 'We have written down some answers to questions that might interest you. If you have more, don\'t hesitate to contact us at <a href=\'mailto:info@koderia.sk\' class=\'tw-text-underline\'>info@koderia.sk</a>.',
      faq_1: 'It is. You pay nothing at all to create, share or print your CV. No ads, no hidden fees. You\'re welcome! 😎',
      faq_2: 'Your CV will be accessible via a pre-created link in the form of <b>koderia.sk/cv/id</b>. You can send this link to anyone.',
      faq_3: 'It is. Just like our website, the CV is available in two languages ​​– English and Slovak.',
      faq_4_1: 'Just follow these steps:',
      faq_4_2: 'Open the subpage about your personal data on LinkedIn – How LinkedIn uses your data',
      faq_4_3: 'Select the option <b>Download larger data archive</b>.',
      faq_4_4: 'Then click <b>Request Archive</b>.',
      faq_4_5: 'Unzip the downloaded file and upload the files <b>Languages</b>, <b>Courses</b>, <b>Positions</b>, <b>Profile</b> and <b>Education</b> to your CV. Then click <b>Import</b>. Please note that LinkedIn may not provide you with the file immediately.',
      ratings: 'What do people in IT who have already tried it think about Koderia CV? 🥰',
      start_new_cv: 'We take care to make every CV look perfect. We leave the next step to you.',
      private_access: 'The CV is either private, accessible to registered users or password protected.',
    },
    actions: {
      create_resume: 'Create CV',
      show_sample: 'Show sample CV',
    },
    invitation: 'Invitation',
  },
  newsletter: {
    subtitles: {
      android_ios_projects: 'The latest Android and iOS projects to your inbox.',
      personalized_jobs: 'Personalised job offers to your inbox.',
    },
    descriptions: {
      send_personalized_projects: 'We will only send you personalised projects that match your focus.',
      no_spam: 'Never any spam',
      koderia_newsletter: 'In the Koderia Newsletter you\'ll only find those job offers that really interest you. Never any spam.',
    },
  },
  promo: {
    title: 'projects for whole teams (35+ people)',
    description: 'We are creating new teams of <span class="tw-font-bold">programmers</span>, <span class="tw-font-bold">testers</span> and <span class="tw-font-bold" >scrum masters</span> for new projects from the banking sector. Work from home for an established client...',
  },
  meta: {
    auth_sign_in: 'Sign in',
    auth_forgot_password: 'Forgot password',
    auth_create_account: 'Create Account',
    work: 'Work',
    events: 'Events',
    blog: 'Blog',
    newsfeed: 'Newsfeed',
    dictionary: 'Dictionary',
    what_is_koderia: 'What is Koderia?',
    adequate_salary: 'Adequate salary',
    adequate_salary_thank_you: 'Thank you - Adequate salary',
    calculator: 'Salary calculator',
    privacy_policy: 'Personal Data Protection Policy',
    resume: 'CV',
    about_us: 'About us',
    extra: 'Extra',
    newsletter: 'Newsletter',
    promo: 'New remote projects for whole teams (35+ people)',
    referral: 'Referral',
    referral_consent: 'Consent - Referral',
    unsubscribe: 'Unsubscribe',
    account: 'Account',
    account_saved: 'Saved - Account',
    account_added: 'Added - Account',
    my_resume: 'My CV',
    registration_completion: 'Completion of registration',
    work_types_comparison: 'Comparison of forms of work',
    frame_help_bratislava: 'Help Bratislava in building a new team of IT specialists.',
    frame_game_industry: 'Work in the game industry.',
    frame_net_teams: 'New jobs for .NET teams',
    404: 'Page not found',
  },
  reviews: {
    list: {
      1: {
        name: 'Adrián Slavkovský',
        position: 'Inventory Skill Centre Coordinator',
        company: 'Orange S.A.',
        text_1: 'In the middle of a project, we decided to include an additional country in the integration process. Nevertheless, Objectify managed to supply the project within the agreed timeframe and in excellent quality.',
        text_2: 'We are sure to continue our cooperation.',
      },
      2: {
        name: 'Ivan Tarapčík',
        position: 'Ebanking Solutions Manager',
        company: 'Asseco Central Europe',
        text: 'By combining their skills in telecommunication fields and implementation in Java, the guys from Objectify significantly helped us in the timely delivery of the Notification Centre Project.',
      },
    },
  },
  company: {
    services: {
      title: 'Services',
      subtitle: 'We are the specialists that do things <br class="tw-hidden md:tw-block" /> right for your next IT project.',
      stats: {
        1: 'developers',
        2: 'revenues last year',
        3: 'business clients',
      },
      fulfilling: {
        title: 'We meet all your IT needs. <br class="tw-block md:tw-hidden" /> From start to finish.',
        description: 'Find the best way of cooperation that suit your needs',
        outsourcing: {
          title: 'Outsourcing',
          description: 'We deliver qualified professionals who meet your needs. The control is yours.',
        },
        scrum: {
          title: 'Our team<br class="{className}" /> on your project',
          description: 'We will provide an experienced team of developers and ensure that they work in the best possible agile development method.',
        },
        owning: {
          title: 'Turnkey software',
          description: 'You give us your goal, and we deliver the whole solution. End to end.',
        },
        responsibility: {
          title: 'Our responsibility',
          low: 'Low',
          high: 'High',
        },
      },
      experience: {
        title: 'Our experience – proven by projects',
        sectors: {
          1: 'Finance',
          2: 'Telco',
          3: 'Medical',
          4: 'Betting',
          5: 'Transport',
          6: 'IT',
        },
        solutions: {
          1: 'Data integration and migration',
          2: 'Data science / Data visualisation',
          3: 'Document management',
          4: 'Data warehouse and reporting',
          5: 'Web',
          6: 'HR / Sourcing',
          7: 'IT project management',
          8: 'Dev/Ops',
        },
        level: {
          expert: 'Experts',
          high_exp: 'High experience',
          medium_exp: 'Some experience',
          low_exp: 'Low experience',
          no_exp: 'No experience',
        },
      },
      benefit: {
        title: 'Benefits of outsourcing with Koderia',
        subtitle: 'Do you need a business solution? <br /> We create robust, reliable, scalable and fast software.',
        personal_benefits: {
          1: {
            title: '12,000+ contractors in our internal database',
            description: 'with skills for each programmer categorised into competency centres, allowing us to precisely target job offers. Our specialists possess a wide range of expertise, including software development, data security, cloud technologies, and many other IT fields.',
          },
          2: {
            title: 'Personalised approach',
            description: 'We consider each contractor/programmer as a part of our own company. We believe that our team of professional IT specialists can provide you not only with high-quality IT services but also with the experience of working with an exceptional team fully dedicated to the success of your project.',
          },
          3: {
            title: 'High-quality selection process',
            description: 'Every team member has passed a thorough selection process and has experience working on various projects cross different industries. We provide professional IT specialists with extensive experience and expert knowledge for our clients projects.',
          },
        },
        enterprise_benefits: {
          1: {
            title: 'Data integration',
            subtitle: 'Is your data spread across a bunch of applications that prevent you from getting one aggregated view or report?',
            description: 'A similar situation in numerous organisations – data are spread across many applications, at different locations, or in various formats. There is no easy way to look at all the data and evaluate it. The data needs to be copied and combined manually, which requires human labour and takes a lot of time.<br /><br /> We pull, shift, and combine data from all types of sources regardless of the location or technology. We provide comprehensive reports, analytics, and graphical views of your data which significantly improves making in your business.',
          },
          2: {
            title: 'High availability',
            subtitle: 'Is downtime of your IT systems causing you financial losses?',
            description: 'There are not many companies in today\'s world that can afford outages in service provision that would not lead to dissatisfaction among their customers. If an application must be in service 24/7, then the demand for a reliable service that runs perfectly, even while undergoing upgrades, is even greater. Our solutions allow for upgrades without an outage of service provision.<br /><br /> We implement systems with high availability architecture that help you to reduce system downtime. Our solution\'s critical components are prepared for any unexpected events that could bring down servers.',
          },
          3: {
            title: 'High scalability',
            subtitle: 'Is your system ready to handle a growing amount of users or data loads?',
            description: 'Many companies face the problem that their systems are not capable of providing services to more customers or that the expansion of their services would lead to lower quality. The performance of their applications limits the growth of their business.<br /><br /> We create applications that can handle an increasing number of users, functions, geographic locations, and data loads. Our systems are adaptable to the requirements of a growing business and highly scalable.',
          },
          4: {
            title: 'Automated testing',
            subtitle: 'How much effort do you have to put into manual testing after every small change in the system?',
            description: 'If you cannot make changes in an application source code without the feeling that something will stop working, it is time to look into automated testing. The same is recommended if your testing team needs a lot of time to retest the old functionality after each release.<br /><br /> We help clients create tests that uncover a broken functionality in backend services or defects in the frontend of the application. In our projects, we use test-driven development. This fixes every reported bug with a specific test. We\'ve also developed Testissimo - a unique solution for automated Ul tests.',
          },
        },
        actions: {
          show_more: 'Show more',
          show_less: 'Show less',
        },
      },
      features: {
        title: 'We have been creating software since 2014. We love quality, maintainability, and functionality. <br /> We also like things to work fast.',
        1: {
          title: 'High scalability',
          description: 'Use our developers that suit your project\'s needs/ The rest is up to you.',
        },
        2: {
          title: 'Releases',
          description: 'We release often. Not every two weeks, not every four weeks, but as soon as it makes sense.',
        },
        3: {
          title: 'Duplication',
          description: 'We make sure we do not duplicate algorithms. Duplication may be the root of all evil in software.',
        },
        4: {
          title: 'Quality check',
          description: 'We use pull requests to ensure quality. Pull requests without automated tests is not our cup of tea.',
        },
      },
    },
    cases: {
      banner: {
        title: 'We are your next IT project\'s specialists, that do things right.',
        description: 'Fulfilling all your IT needs. End to end.',
        action: 'Learn more',
      },
      subtitles: {
        problem_definition: 'Problem definition and goal',
        challenges: 'Challenges',
        solutions: 'Solutions',
      },
      competencies: 'Core competencies',
      technologies: 'Technologies',
      features: {
        data_analytics: 'Data analytics',
        data_visualization: 'Data visualization',
        data_warehouse: 'Data warehouse',
        data_integration: 'Data integration',
        data_modeling: 'Data modeling',
        document_management: 'Document management',
        distributed_applications: 'Distributed applications',
        android_app: 'Android app development',
        application_integration: 'Application integration',
        agile_development: 'Agile development',
        automated_testing: 'Automated testing',
        high_availability: 'High availability',
        high_scalability: 'High scalability',
        high_data_volume_processing: 'High data volume processing',
        microservices: 'Microservices',
      },
      domains: {
        railways: 'Railways',
        construction: 'Construction',
        renewable_energy: 'Renewable energy',
        biometrics: 'Biometrics',
        telecommunications: 'Telecommunications',
        healthcare: 'Healthcare',
        community: 'Community',
      },
      list: {
        railways: {
          title: 'Data Warehouse for Rail Defectoscopy',
          description: 'Railways of the Slovak Republic ordered a diagnostic vehicle for non-destructive testing from a consortium of companies, which delivered the vehicle, measuring technologies, and the software to evaluate all the measured data. For this consortium, we created a warehouse and an analytical tool that displays the data in a user-friendly portal.',
          problem_definition: 'Measurement systems produce a huge amount of data, which needs to be transferred to a datastore and later cleaned and transformed into a format understandable to a common user. Due to the size of the database, which is estimated to be ca. 5TB, the data must be transformed into a format that is optimized for future display on the portal. The application must provide a user interface that displays the requested data with fast response times and is able to present the measured data on an underlying map.',
          challenge: {
            description: 'The project involves a large volume of measured data that needs to be transferred from a locomotive to a server, then cleaned and transformed into a format that enables later data analysis and provides short response times for the presentation layer.',
            list: {
              1: {
                title: 'Cooperation of multiple vendors',
                description: 'One of the challenges was also to arrange cooperation among several companies, including multiple vendors of measuring systems and multiple vendors of software solutions.',
              },
              2: {
                title: 'About the customer',
                description: 'Railways of the Slovak Republic manages the state-owned railway infrastructure on the territory of the Slovak Republic and at the same time provides also transportation services.',
              },
            },
          },
          solution: {
            description: 'The data warehouse consolidates vast amounts of information collected from measurement systems installed on the locomotive. This warehouse efficiently stores, cleans, and transforms raw measurement data into a structured format, enabling comprehensive analysis and reporting. It supports advanced data analytics, facilitating the identification of rail defects, trends and patterns over time.',
            list: {
              1: {
                title: 'Campaigns',
                description: 'The measurements of selected track sections are planned in advance as part of a measurement campaign. When creating a campaign, a user has to define the entire route plan for the diagnostic vehicle, including details regarding the vehicle\'s speed, types of diagnostics, and scheduled stops at stations.',
              },
              2: {
                description: 'After completing a campaign, a user can view and analyze the collected data. It is possible to download the original files produced by the measuring systems, view pictures or videos from cameras, and locate the defects on a map.',
              },
              3: {
                description: 'Campaigns and all associated files have their own lifecycle, which helps users to analyze the results and plan subsequent repairs.',
              },
              4: {
                title: 'Dashboard',
                description: 'The application features a comprehensive dashboard with interactive tiles, allowing users to easily navigate to various screens such as reports, campaigns or files. Each tile provides quick access to different functionalities, ensuring an intuitive and efficient user experience. The dashboard serves as the central hub, offering an overview of key information and functionalities. Users can access detailed reports, manage campaign data, and navigate to all other screens directly from the dashboard.',
              },
              5: {
                title: 'Reports',
                description: 'The application includes a variety of reports to support comprehensive data analysis and decision making. These reports encompass outputs from measurements, detailing precise data collected during campaigns. Error reports highlight any anomalies or issues detected in the data. Sectional assessment reports provide an evaluation of specific track sections, while status of measurement reports offer real-time updates on the progress and results of ongoing measurements. Additionally, frontal photo reports present visual documentation from cameras, aiding in the identification and verification of defects. Each report is designed to provide clear and actionable insights, enhancing the overall efficiency and effectiveness of the rail maintenance process.',
              },
            },
          },
        },
        cx_android: {
          title: 'Cx Android App',
          description: 'The application provides functionality for managing tasks related to the commissioning of construction projects. It facilitates collaborative issue management, tracks assets, and ensures quality verification with usage of checklists and tests.',
          problem_definition: 'Our customer had existing commissioning management software accessible via a web browser as a common web application or as an iOS app available in the App Store. They needed an Android application that would provide identical functionality to the iOS app.',
          challenge: {
            list: {
              1: {
                title: 'Customer',
                description: 'CxAlloy provides commissioning management software and facility management software to customers in North America.',
              },
              2: {
                title: 'Core features',
                list: {
                  1: 'Multiple project support',
                  2: 'Automatic synchronization with server',
                  3: 'Usage in offline mode',
                  4: 'Creation and modification of field observations',
                  5: 'Quality verification using checklists and tests',
                  6: 'Issue management',
                  7: 'Asset tracking',
                },
              },
            },
          },
          solution: {
            list: {
              1: {
                description: 'The application allows users to manage multiple projects. It ensures synchronization of data changes between the client and the application server. Multiple users can work on the same project simultaneously across various platforms (iOS, web, Android). Advanced algorithms on the server side ensure the integrity and correctness of the data when the same project is used in parallel by different users.<br /><br /> Various files and file types (e.g., pictures or PDFs) can be attached to each project. Additionally, users can add annotations to these files, which are displayed in a layer above the file. This annotation layer can be modified as needed.',
              },
              2: {
                description: 'Field observations allow users to document their progress regarding onsite construction activities. These observations can be utilized by different project roles, including architects, engineers or consultants. Field observations management also includes the ability to create and modify comments, with options for attaching pictures.',
              },
              3: {
                title: 'Issue tracking',
                description: 'The application enables efficient collaboration on design and construction issues, which can originate from various sources such as field observations or tests. Issues can include deficiencies, questions or comments. A flow between various states of an issue is supported by the application, which can result in the creation of additional tasks or the assignment of an issue to different persons. The application contains also issue templates, which simplifies the creation of new issues.',
              },
            },
          },
        },
        pv_components: {
          title: 'Photovoltaic Components Catalog',
          description: 'We have created a web application, one of whose main goals is to provide access to accurate and verified technical specifications of PV components, such as PV modules or inverters.',
          problem_definition: 'Most manufacturers of photovoltaic components primarily showcase their products on their respective websites. However, when users seek to compare and evaluate items from multiple manufacturers in a standardized manner, there are few public portals that facilitate such comparisons. A key objective of this project was to present photovoltaic components from various regions or manufacturers in a cohesive manner.<br /><br /> Equally crucial is the provision of an API for third-party applications, enabling them to utilize portal data for their own purposes and better serve their customers. For instance, this API could aid in evaluating different product types for designing a photovoltaic power plant.',
          challenge: {
            list: {
              1: {
                title: 'Implementation',
                list: {
                  1: 'Serverless architecture on AWS',
                  2: 'Faceted navigation using only PostgreSQL (without usage of ElasticSearch or Solr)',
                  3: 'Complex mathematical validations',
                },
              },
              2: {
                title: 'Customer',
                description: 'Our customer is a leading provider of photovoltaic software applications and web-based solutions for the optimization of construction, evaluation, and management of solar power assets.',
              },
            },
          },
          solution: {
            list: {
              1: {
                title: 'Core features',
                list: {
                  1: 'Registration of PV components, including support for multiple versions of a component',
                  2: 'Validations and calculations of component attributes',
                  3: 'Searching capabilities (full-text search, faceted search)',
                  4: 'Comparisons of components',
                  5: 'Rest API for third-party applications',
                  6: 'Exports and imports of components in commonly used formats',
                },
              },
              2: {
                title: 'Catalog of components',
                description: 'The application enables users to display a list of items that can be filtered based on various criteria such as manufacturer name, mechanical or electrical characteristics, and more. Additionally, full-text search and faceted search functionalities are provided to facilitate convenient searching on the portal for users.<br /><br /> The application is accessible to the public.',
                a_tag: 'Go to PV components catalog',
              },
              3: {
                title: 'Statistics',
                description: 'In addition to basic catalog display functionality, the application offers screens for supervisory workers, allowing them to access statistical information about the collection of items displayed in the catalog or utilized by third-party companies. Furthermore, providing statistical insights into the usage of the API by selected companies is a standard feature of the portal.',
              },
              4: {
                title: 'Administration',
                description: 'The administration section of the portal allows for comprehensive management of users and companies. It enables the registration and management of user accounts, oversight of company registrations, and verification of component data accuracy and completeness. Additionally, it includes tools to monitor activities related to the usage of the API by third-party applications.',
              },
              5: {
                title: 'Tech stack',
              },
            },
          },
        },
        enrollment: {
          title: 'Enrollment portal',
          description: 'A biometric identification solution for various purposes, from civil identification to criminal investigation.',
          features: ['Agile development', 'Data visualization', 'Application integration'],
          problem_definition: 'We have implemented a solution for capturing biometric data using libraries and SDKs created by Innovatrics. The portal solution offers features that can be used for civil identification or criminal investigation. The application allows the usage of various devices to capture fingerprints or iris scans. Additionally, a wide range of camera types is supported.',
          challenge: {
            list: {
              1: {
                title: 'Customer',
                description: 'Innovatrics is an independent EU-based provider of trusted biometric solutions for governments and enterprises.',
              },
              2: {
                title: 'Core features',
                list: {
                  1: 'Face detection and facial recognition',
                  2: 'Iris scans',
                  3: 'Plain and rolled fingerprint scans',
                  4: 'Palm scans',
                  5: 'Handwritten signatures',
                },
              },
            },
          },
          solution: {
            list: {
              1: {
                description: 'All the modalities that are captured from applicants are configurable. It means a customer can decide for a deployment just with support e.g. of face detection and plain fingerprint scans or for a deployment with all-features support.<br /> Face detection and subsequent facial recognition are the core features of the enrollment portal. Iris scans are also one of the common features offered by the application.',
              },
              2: {
                title: 'Fingerprint scans',
                description: 'The application supports both plain and rolled fingerprint scans. With the plaintype, users can switch between slaps mode and single finger scans.',
              },
              3: {
                title: 'Applicant identification',
                description: 'In the final step the system utilizes biometric recognition technologies to identify the applicant. Leveraging facial recognition, iris scans, and fingerprint data, the application employs sophisticated algorithms to match the captured biometric information against existing records in its database. By employing these robust biometric modalities, the application ensures a highlevel of accuracy and security in the identification process, facilitating reliable decision-making in various scenarios, from civil identification to criminal investigation.',
              },
            },
          },
        },
        sia: {
          title: 'SIA – Service Impact Analysis',
          description: 'SIA is an evolution of our previous project CELINE which goal was the integration of various inventory data sources into one application. Although CELINE was developed for Orange France, the project caught the attention of the whole Orange group. In particular, Orange Slovakia came up with a requirement not only to integrate their inventory-related data source but to use this data to answer seemingly simple questions: What would happen if a particular network element experiences an outage? Which services and customers might be affected and how will the outage spread through the network? We have developed SIA to answer these questions.',
          problem_definition: {
            text_1: 'There are three situations when a user needs to aggregate a lot of data to find the answer about the potential impact on customers and their products.',
            list: {
              1: 'In case of planned network element upgrade, decommissioning, or any change which might affect its functionality',
              2: 'In the case of device outage identified by operation teams and monitoring tools',
              3: 'In case of customer complains about service malfunction',
            },
            text_2: 'In all of these situations, many users had to collaborate, access many tools, and compile the results to find the corresponding answer. This process is error–prone and in more complicated cases (e.g. decommissioning of metropolitan optical cable) might take two weeks to finish.',
          },
          challenge: {
            description: 'We had to face the same challenges as in the CELINE project. This project moves the requirement even further and thus a new set of challenges in addition to those from CELINE.',
            list: {
              1: {
                title: 'Find relations across huge graphs in real-time',
                description: 'If you want to calculate all services which rely for example on a given metropolitan optical cable, you not only need high quality and strongly correlated data but you will also need to inspect large parts of the network both vertically and horizontally. The problem with such reports is also that you don’t know how “deep” you need to search.',
              },
              2: {
                title: 'Complete the missing data',
                description: 'Although successfully correlating data from all existing inventory systems and all network management systems in Orange Slovakia, there still were gaps which we had to fill to have the full picture of the network. For example, no data source would describe service architecture in the detail of particular network elements.',
              },
              3: {
                title: 'Impact visualization',
                description: 'The requirements were to provide a list of services and customers impacted by network element outages. This list is used for example to inform customers about planned outages. Even if we would have had the list, then the question of “how could the user validate that the list is correct?” would arise. Another question we had to keep in mind was “how could the user understand what is the chain of the outage which results in an impact on this particular customer?”.',
              },
            },
          },
          solution: {
            description: 'Luckily, we had already a production system in place and a lot of experience in the domain of telecommunication inventory integration from our previous project CELINE. We decided to reuse our solutions and code. Also, we further used this opportunity to modernize our code stack, refactor important parts which would later become more optimized, and created a better product for bot CELINE’s and SIA’s use-case.',
            list: {
              1: {
                title: 'Find relations across huge graphs in real-time',
                description: 'We have decided to continue using our standard relational database as our main persistent storage. However, to be able to search in the huge graphs in real-time, we have introduced a specialized graph database, NEO4J, which greatly enhanced our possibilities in performing analyses of the telecommunication network. The data in NEO4j are synchronized from our main persistent database and are de-normalized and enhanced to further speed-up the network impact analyses.',
              },
              2: {
                title: 'Complete the missing data',
                description: 'We had to adjust the implementation of our tool to not only show and analyze data integrated from other systems but also to allow the user to edit and further enhance this data. Part of the data which was missing is service architected which naturally has a form of a diagram. We have designed a specialized DSL (domain-specific language) that allows creating such a diagram very effectively from underlying inventory objects.',
              },
              3: {
                title: 'Impact visualization',
                description: 'To give the user more information about the impact characteristics or reasons why the tool included some customers in the impact report we had to design specialized views on the impact data. For example, users can choose to visualize the impact on a map to see how the impact of one site outage will spread in the geographic space. Besides, users can visualize the full path from the specific customer devices to the network elements used by all customers for the given service.',
              },
            },
          },
        },
        celine: {
          title: 'Celine',
          description: 'CELINE is an umbrella inventory management system that gathers data from Orange affiliates on their network infrastructure and presents it in a unified way. CELINE is used by GNOC (Global Network Operation Center), which is responsible for operating networks in various Orange affiliates. GNOC is using CELINE as a primary source of inventory-related data regarding the network infrastructure it maintains.',
          problem_definition: {
            text: 'CELINE was designed for GNOC (Global network operation center). GNOC is responsible for the maintenance of Orange affiliates network infrastructure. To achieve this goal, access to information about the network’s infrastructure is paramount.<br /><br /> The original approach for GNOC with regards to inventory management was to access whatever tools are available in the country for which they provide services. It was clear early on that working with different systems from huge inventory solutions like NetCracker to Excel spreadsheets was not efficient. Therefore, it was identified that there should be a single inventory solution for GNOC that integrates all data sources available. One could describe the situation as following:',
            header_1: 'Before Celine',
            header_2: 'After Celine',
          },
          challenge: {
            description: 'OBJECTIFY has been part of the CELINE project from the very beginning. Our first contribution to the project was to define the problem faced by the GNOC: accessing information scattered across many different data sources. Soon it was clear that we would have many significant challenges to face:',
            list: {
              1: {
                title: 'Data diversity',
                description: 'The applications storing the network infrastructure data were hugely different from each other in terms of APIs, level of detail, and data models. Our goal was to create a unified view of the data for the user. From the user perspective, the representation of a server or router (as an example) should be the same independent, if the original data came from NMS’s (Network Management Systems), Excel Spreadsheets, or Inventory tool.',
              },
              2: {
                title: 'Data synchronization',
                description: 'It was not possible to replace all the tools used by Orange affiliates because they’re part of the day-to-day work of local engineers and integrated with other specific IT solutions.',
              },
              3: {
                title: 'Information instead of data',
                description: 'Even if the data from the various data sources will be in the same application, to provide real benefit, these data need to be correlated to each other, they need to be aggregated into user reports and accessible via standardized APIs for further automation and reporting tools.',
              },
              4: {
                title: 'Data quality assurance',
                description: 'It is common for inventory systems to have data that is out of date. The problem becomes even bigger when 3rd party companies, with no management authority (GNOC), need to initiate data cleaning or update stale data.',
              },
            },
            post_list_description: 'There are significant project management issues related to projects with so many participants but, this goes beyond the scope of this case-study.',
          },
          solution: {
            description: 'OBJECTIFY was active in the telecommunication inventory management domain long before this project. Through our experience, we gained valuable expertise without which we could never have delivered these solutions:',
            list: {
              1: {
                title: 'Data Diversity',
                description: 'We have created an inventory data model starting with very generic terminology to more specific types. This model could be extended and can document any inventory situation we might encounter in the data sources, which were not even identified during that time. The result was “Common data model” that we have described and tested in detail.',
              },
              2: {
                title: 'Data synchronizations',
                description: 'We have created specialized data pumps to collect and transform data to the “Common data model” and send the aggregated view after each synchronization to a centralized inventory in Poland. These data pumps allow custom connections and transformations for each data source. All the downstream calculations, transformations, and algorithms are generic and independent of the data source.',
              },
              3: {
                title: 'Data quality assurance',
                description: 'We always need to make sure the data presented to the user is correct. We have implemented mechanisms to identify data inconsistencies like reference integrity and data invariants. We have also allowed users to override data coming from a source system while making sure that such corrections are consistently visible across the whole application (the original value from the data source and the corrected value by GNOC).',
              },
              4: {
                title: 'Information instead of data',
                description: 'Having the data does not mean that the user receives all the information they require. To solve this issue, we have put a lot of emphasis on search capabilities across all inventory objects and attributes. Part of the CELINE solution is integration with our own DMS tool that provides storage for unstructured data (work instructions, manuals, common problems, and solutions) and integrates this information into CELINE. We have also designed and implemented many custom reports which are tailor-made for the daily information requirements of GNOC engineers. These reports allow an aggregated view of data from various sources.',
              },
            },
          },
        },
        dms: {
          title: 'DMS',
          description: 'The DMS application is a centralized, web-based storage for all digital content; documents, photos, wiki pages, and decision trees. It is designed to horizontally scale to handle large data volumes. Part of the solution is a rule-based loader that can connect to various data sources and migrate or synchronize content to DMS.',
          problem_definition: 'Part of building network infrastructure for telecommunication operators is creating a lot of different documents like lease contracts, CAD drawings, measurements, installation materials, and so on. When the telecommunication site is operational, other activities like site revisions are performed which generate further documentation.<br /><br /> All these documents were previously stored on a single shared drive and as the volume of documents grew, it became harder and harder to find the right ones. To work around this problem, users started to create their own folder hierarchies, which meant duplicating some of the documents. The shared drive also had other problems, like lack of full-text search, no traceability, poor user rights management, and so on, which needed to be solved.',
          challenge: {
            description: 'This project involved a large amount of unstructured data, which needed to be categorized, so that users could find what they need no matter what role in the organization they play. The documents were created and used by internal Orange employees as well as users from external companies.',
            list: {
              1: {
                title: 'Document organization',
                description: 'It was obvious from analyzing the documents stored on the shared drive that users have different “views” on document categorization. For some users, categorization was “Site-centric” whereas other users categorized based on “Time-centric” priorities. This resulted in different folder hierarchies and document fragmentation.',
              },
              2: {
                title: 'Structured and unstructured data',
                description: 'Although most data have been stored in documents, some information was stored in the folder structures themselves. Document type, site number, year, and much more were encoded in folder names that prevented proper use of this information.',
              },
              3: {
                title: 'Duplication and quality assurance',
                description: 'It often happened that users missed some mandatory folders that resulted in wrong document categorization or uploading a document, which was already there.',
              },
              4: {
                title: 'Search',
                description: 'The primary concern of a shared drive document storage system was poor usability when searching for documents. It was not possible to use full-text search, and it was hard to navigate via folder hierarchies and resolve duplicates.',
              },
              5: {
                title: 'Security and trackability',
                description: 'If users moved documents to another location or accidentally deleted documents, it was not possible to trace which user it was. It was also not easy to protect documents from unauthorized access.',
              },
              6: {
                title: 'Data import',
                description: 'There was already a large set of documents stored in the shared drive, which had to be loaded to DMS without losing information about its categorization.',
              },
              7: {
                title: 'Data to information',
                description: 'User have no easy option to get answer for a simple question: How many sites exists, which do not have electric revision for the year 2020.',
              },
            },
          },
          solution: {
            description: 'At OBJECTIFY, we created a web-based DMS system, which was not organized around folders but instead allowed to define custom fields on documents that could be used to store different meta-data as well as for searching.',
            list: {
              1: {
                title: 'Document organization and structured data',
                description: 'Using folders to categorize documents have some major drawbacks; users must agree on a single hierarchy of folders and assign documents accordingly. Additionally, folders do not give any information about the data it contains. That is why we decided not to use folders at all. In DMS, all structured information (Project, Creation date, Document type, anything you like) is stored in a specific document attribute that allows for advanced filtering, reporting on documents, validations, permission rules based on attribute values, and more.',
              },
              2: {
                title: 'Preventing duplication and wrong categorization',
                description: 'Users can define document types and their attributes. They can also customize which fields are mandatory. To prevent users from duplicating content, we have implemented a search for identifying similarities in content and alerting the user of results found. Additionally, users can define “Upload trees” to easily upload different types of documents for a given scenario. Users can also configure rules to include structured information from folders being uploaded.',
              },
              3: {
                title: 'Search',
                description: 'We use Apache Solr to index documents and search full-text with word occurrence highlighting typeahead features, or spellcheck corrections. Further, we implemented a faceted search so that users can easily narrow down Full-text search results. The faceted search also allows for hierarchy independent search order; “Site-centric” users can start by filtering via Site, and “Time-centric” users filter via a data range.',
              },
              4: {
                title: 'Security and trackability',
                description: 'We have implemented a security mechanism to DMS that can be finetuned to the level of single documents. Users can specify access rights individually for each document or configure rules based on document field values. Furthermore, we keep a detailed log of activity on each document, so no user action gets lost.',
              },
              5: {
                title: 'Data import',
                description: 'To be able to migrate data to DMS, we have implemented a stand-alone migration tool with a configurable rule engine, which not only migrates documents but can synchronize documents from various data sources (shared drive, share point, database, …) This way DMS can be used not only as document storage but also as a search engine for other applications.',
              },
              6: {
                title: 'Data information',
                description: 'Having all structured data stored in dedicated fields allowed us to create a reporting engine, where users can create tabular reports to follow the progress of installations, document statistics, and much more.',
              },
            },
          },
        },
        dodes: {
          title: 'Dodes',
          description: 'Dodes is the abbreviation for Diagnostic nodes. It is a methodology designed by Prof. Dr. Paul Martin Putora from St. Gallen hospital in Switzerland.',
          problem_definition: 'A medical guideline is a document with the aim of guiding decisions and criteria regarding diagnosis, management, and treatment in specific areas of healthcare. These guidelines are updated regularly and are often in the form of “free text” documents.<br /><br /> A healthcare provider is obliged to know the medical guidelines of his or her profession and must decide whether to follow the recommendations of a guideline for individual treatment. It is important to find a way to promote the newest guidelines and draw attention to possible diverges between the guidelines and widespread practice.<br /><br /> Prof. Dr. Paul Martin Putora proposed a method to document the decision-making process in a structured way. He used the decision tree notation that condensed the information in a very efficient and readable way and also allowed to compare the decision-making process between different healthcare providers.',
          challenge: {
            list: {
              1: {
                title: 'Terminology unification',
                description: 'The treatment decisions are based on parameters which can have different names in different hospitals. Even when the different hospitals use the same names for same parameters, they might express parameter values in different units; for example, glucose can be measured in mmol/l as well as mg/dl. To perform calculations, this terminology had to be unified or at least be mappable.',
              },
              2: {
                title: 'Comparison trees',
                description: 'The decision trees can be documented in diverse ways. Some prefer to use complex mathematical expressions to define when a given action is performed when others use simple logical expressions. Some medical centers can omit certain parameters because the measurements for that parameter have not been taken. To find differences in such complicated structures was not trivial.',
              },
              3: {
                title: 'Huge state-space',
                description: 'The decision-making comparison has been performed in studies where more than 10 hospitals took part. One treatment can depend on 10+ parameters. To evaluate such state-space, we can easily end up with billions of combinations that need to be evaluated.',
              },
              4: {
                title: 'Data presentation',
                description: 'The differences between treatments can be quite profound. It is complicated to get the right insights from the results unless users investigate the result in detail.',
              },
            },
          },
          solution: {
            list: {
              1: {
                title: 'Terminology unification',
                description: 'Before the decision tree for a particular treatment can be created the terminology has to be unified in the treatment template. This template defines a vocabulary for decision trees in terms of the parameters that must be considered in the treatment as well as actions that can be performed. When the user is creating a decision tree, the system is using the template to provide guidance and ease the process of input.',
              },
              2: {
                title: 'Comparison trees',
                description: 'We have implemented algorithms that can transform the decision tree into a multidimensional state-space and can assign each “coordinate” a set of actions for a given parameter range. This allows us to compare each coordinate to find differences. From this information, we can back generate a decision tree that represents comparison results. We can use the same approach to enhanced the validation of decision trees like calculate parameter ranges that do not have any action or have contradictory conditions.',
              },
              3: {
                title: 'Huge state-space',
                description: 'To compute large decision trees from many institutions, we have implemented parallelized computation, using the google task queue. The computational state-space is divided into many smaller spaces that are sent to the task queue. This service spans as many computers as needed and performs the computation in parallel, returning results that are merged into a single comparison result. This way, we can perform comparison calculations in near real-time.',
              },
              4: {
                title: 'Data presentation',
                description: 'To reduce comparison results, users can use filters actions, or parameter values and thus reduce the state-space to much smaller sizes. We are still investigating options to make the comparison result more compressed and readable. Currently, we are experimenting using correlation matrixes.',
              },
            },
          },
        },
        koderia: {
          title: 'Koderia',
          description: 'Koderia is an online portal for developers and students with a focus on software engineering. The portal brings information about the industry such as articles, events, job posts, and original content – blogs, but also offers additional support such as payroll calculator, adequate salary calculator technical dictionary, etc.',
          challenge: {
            description: 'Lots of companies offer open positions to software developers. We had to distinguish and create a product, which will be unique. At the same time, it was important to build trust between the company and developers.',
            list: {
              1: {
                title: 'Our goal',
                description: 'The main goal of Koderia (formerly campaigned as “Developers for Developers”) was to increase the amount of email subscribers for our open positions at Objectify.',
              },
            },
            post_list_description: {
              header_1: 'The beginning of the multi-functional portal',
              text_1: 'Started as a simple website with a simple form, where developers were able to find out how much they should earn (Adequate salary calculator). We had a proper knowledge of the economic situation in the industry so we were able to deliver personal, quick and adequate responses. The campaign was popular among developers and gained hundreds of new contacts. At that point, we decided to create an online space that will merge all important information about the industry into a one place.',
              header_2: 'Moving to Vue and Firestore',
              text_2: 'As Koderia grew, it became apparent that WordPress simply won’t be enough.',
              text_3: 'The decision to go with Firebase proved to be a beneficial one. Firebase offered us many out-of-the-box customizable features such as:',
              list: {
                1: 'Realtime Database was used until more querying possibilities were needed, while Firestore provides everything we needed since and probably will ever need concerning the Koderia project.',
                2: 'Cloud Functions proved to be a fitting replacement for a standard backend.',
                3: 'Firebase Authentication was a pleasant feature to use and implement. Providers such as Google, Facebook, Github (and also standard email + password) were implemented with ease.',
                4: 'Firebase CI/CD also offered us an easy-to-use deployment solution that we have set up and used since our first release.',
              },
              text_4: 'Graphs, visualizations, and much more can now be found at Koderia. We pay many thanks to chart.js. Integrating this library along with many other both external and custom-made libraries was effortless.',
            },
          },
          solution: {
            list: {
              1: {
                title: 'Koderia CV',
                description: 'Most advanced feature of Koderia is a unique CV developed for software engineers. Design of the CV is adjusted for the software industry and helps to communicate information in an easier and tidier way, than most of the other CV service available. Developers are then able to apply for open positions on Koderia, or anywhere else. While building this feature our main aspects of the product were:',
                cards: {
                  1: {
                    title: 'Responsivity',
                    description: 'The CV had to be easily readable on all devices and print',
                  },
                  2: {
                    title: 'Language selector',
                    description: 'Users have to be able select languages',
                  },
                  3: {
                    title: 'Security',
                    description: 'For more privacy, users are able to switch their CVs to private mode',
                  },
                },
              },
              2: {
                title: 'Payroll calculator',
                description: {
                  text_1: 'Payroll calculator let users calculate their income based on type of their employment. The feature brigs rich visual representation of all the expenses and taxes. The main goal is to educate and explain, what type of employment is better in their situation. Many Slovak companies, especially in IT industry, offers contract instead of permanent employment. As the salary varies in these cases, the user is informed about all the differences.',
                  text_2: 'To learn more visit',
                  a_tag: 'Koderia Payroll Calculator',
                },
              },
              3: {
                title: 'Original content',
                description: {
                  text_1: 'Koderia creates a place, where users are always able to find new and fresh information related to the software industry. This is made of sections that deliver dynamic content:',
                  text_2: 'Koderia kept the first feature – The adequate salary calculator, which is now also integrated into CV. There is no need to fill another form. When the CV is created, the adequate salary is calculated too.',
                  text_3: 'Throughout the time the project is online, Koderia established its place in Slovakia and plans to continue with the support for developers, bringing new features and improve existing ones.',
                },
                cards: {
                  1: {
                    title: 'Posts',
                    description: '3rd party articles and videos, carefully selected by us',
                  },
                  2: {
                    title: 'Events',
                    description: 'One place for all the offline and online IT events in Slovakia',
                  },
                  3: {
                    title: 'Blogs',
                    description: 'Space for our thoughts and anyone who wants to share their ideas among our audience',
                  },
                  4: {
                    title: 'Jobs',
                    description: 'Our primary content lets users find their next profession in IT industry',
                  },
                },
              },
            },
          },
        },
      },
    },
  },
}

export default en
